import React from "react";
import { CumulativePlayTestsChart } from "./Chart";
import { SinglePageView } from "../core/ListView";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const CumulativePlayTests = ({ gameId }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);

  const validPlayTests = playTests.filter((pt) => pt.ignore);

  return (
    <SinglePageView title={`Cumulative Play Tests Over Time`}>
      {validPlayTests.length === 0 ? (
        <Box p={1}>
          <Alert severity="warning">
            No play tests found. Add some play tests to see the cumulative progression over time.
          </Alert>
        </Box>
      ) : (
        <Box p={1}>
          <Alert severity="info">
            This chart shows the cumulative number of play tests over time, helping you visualize your play testing
            progress.
          </Alert>
        </Box>
      )}
      <CumulativePlayTestsChart gameId={gameId} />
    </SinglePageView>
  );
};
